import TrackLogo from "./track-logo/TrackLogo";
import { Button, Col, Row } from "antd";
import TrackProgressBar from "./track-progress-bar/TrackProgressBar";
import "./TrackDisplay.css"
import { StepForwardOutlined, StepBackwardOutlined } from "@ant-design/icons"

const TrackDisplay = ({ trackName, artistName, handlePrev, handleNext }) => {
  return (
    <div className="track-display-container">
      <Row gutter={16} align="middle" wrap={false}>
        <Col flex="none">
          <Button type="text" onClick={handlePrev}>
            <StepBackwardOutlined className="track-display-button" />
          </Button>
        </Col>

        <Col flex="none">
          <TrackLogo />
        </Col>

        <Col flex="180px">
          <div className="track-details-container">
            <h3 className="track-display-name">{trackName.toUpperCase()}</h3>
            <p className="track-display-artist">{artistName.toUpperCase()}</p>
            <TrackProgressBar />
          </div>
        </Col>

        <Col flex="none">
          <Button type="text" onClick={handleNext}>
            <StepForwardOutlined className="track-display-button" />
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default TrackDisplay;
